export default __webpack_public_path__ + "static/media/rebel.00eae910.png";